import { render, staticRenderFns } from "./Borrados.vue?vue&type=template&id=53fd8159&"
import script from "./Borrados.vue?vue&type=script&lang=js&"
export * from "./Borrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports